import { useItinerariesQuery } from 'core/graphql/Itinerary/ItineraryVersions.generated';
import { ItineraryVersion } from 'core/graphql/types';

type ItineraryVersionsResult = {
  itineraries: ItineraryVersion[];
  loadingItineraries: boolean;
  refresh: () => Promise<void>;
};

const useItineraryDataStore = (
  date: string | null,
  courierId: number | null,
): ItineraryVersionsResult => {
  const { loading, data, refetch } = useItinerariesQuery({
    skip: !courierId || !date,
    variables:
      date && courierId
        ? {
            date,
            courierId,
          }
        : undefined,
  });

  const refresh = async () => {
    await refetch(
      date && courierId
        ? {
            courierId,
            date,
          }
        : undefined,
    );
  };

  if (data !== undefined) {
    return {
      itineraries: data.Itineraries,
      loadingItineraries: loading,
      refresh,
    };
  }

  return {
    itineraries: [],
    loadingItineraries: loading,
    refresh,
  };
};

export default useItineraryDataStore;
